<app-text class="d-flex align-items-center tag2 cursor" *ngIf="type === 'type2'" (click)="clickedTag(tagName)">
    <app-image [src]="'./assets/icons/subtract.svg'" style="margin-bottom: 3px;margin-right: 8px;"></app-image>
    <app-text class="caption text-c100">{{tagName.name ? tagName.name : tagName}}</app-text>
</app-text>

<app-text class="d-flex align-items-center justify-content-center bg-c75" *ngIf="type === 'type1'" [ngClass]="{'tag1-1' : class == 'tag1-1', 'tag1' : class !== 'tag1-1'}">
    <app-text class="small text-s0">{{tagName}}</app-text>
</app-text>